var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('SaralaTable',{ref:"table",attrs:{"model":_vm.model},on:{"process":function($event){return _vm.process($event)}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }